/*eslint-disable*/
import React from "react";
// react components for routing our app without refresh
import { Link } from "gatsby";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Hidden from "@material-ui/core/Hidden";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Tooltip from "@material-ui/core/Tooltip";

// @material-ui/icons
import { Apps, CloudDownload } from "@material-ui/icons";

// React icons
import { FaTwitter, FaFacebook, FaInstagram } from 'react-icons/fa';

// core components
import CustomDropdown from "components/CustomDropdown/CustomDropdown.jsx";
import Button from "components/CustomButtons/Button.jsx";
import JoinModal from "components/JoinModal/JoinModal.jsx";
import SocialMediaLinks from "components/SocialMediaLinks/SocialMediaLinks.jsx";

import headerLinksStyle from "assets/jss/material-kit-react/components/headerLinksStyle.jsx";

function HeaderLinks({ ...props }) {
  const { classes } = props;
  return (
    <List className={classes.list} role="navigation" aria-label="Main">
      <Hidden mdUp>
        <ListItem className={classes.listItem}>
          <Button
            color="transparent"
            className={classes.navLink}
          >
          <Link to={"/"} style={{color: "inherit"}}>
            Home
          </Link>
          </Button>
        </ListItem>
      </Hidden>
      <ListItem className={classes.listItem}>
        <Button
          color="transparent"
          className={classes.navLink}
        >
        <Link to={"/athena/"} style={{color: "inherit"}}>
          athena
        </Link>
        </Button>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Button
          color="transparent"
          className={classes.navLink}
        >
        <Link to={"/votingfunds/"} style={{color: "inherit"}}>
          voting funds
        </Link>
        </Button>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Button
          color="transparent"
          className={classes.navLink}
        >
        <Link to={"/about/"} style={{color: "inherit"}}>
          About
        </Link>
        </Button>
      </ListItem>
      <ListItem className={classes.listItem}>
        <JoinModal classes={classes}  listIds={[20]}/>
      </ListItem>
      <Hidden mdUp>
      <ListItem className={classes.listItem} style={{
        paddingLeft: "15px"
      }}>
        <SocialMediaLinks classes={classes} />
      </ListItem>
      </Hidden>
    </List>
  );
}

export default withStyles(headerLinksStyle)(HeaderLinks);
